import { api } from '@/core/lib/apiClient';
import { bookmarksService } from '@/core/services/bookmarksService';
import { useSessionStore } from '@/core/stores/sessionStore';

export interface SourceComment {
  id: string;
  body: string;
  author: string;
  handle: string;
  parentId: string | null;
}
export interface Reference extends Partial<SourceComment> {
  excerpt?: string;
  edited?: boolean;
  unavailable?: boolean;
}
export interface ToolsState {
  question: boolean;
  updates: { id: number; body: string; createdAt: string }[];
  helpful: (SourceComment & { reason: string })[];
  contexts: Record<string, { references: Reference[]; reconsidered: SourceComment | null }>;
  private: { labels: string[]; snoozedUntil: string | null; snoozedForever: boolean } | null;
}
export interface Invitation {
  id: number;
  postId: string | null;
  sender: string;
  recipient: string;
  incoming: boolean;
  state: 'pending' | 'accepted' | 'declined';
  createdAt: string;
}
export interface Library {
  bookmarks: { postId: string; commentId: string | null; note: string; body: string }[];
  discussions: { postId: string; body: string; labels: string[] }[];
}
export const toolsUrl = (postId: string) => `/discussion-tools/${encodeURIComponent(postId)}/`;
export const discussionTools = {
  get: (postId: string) => api<ToolsState>(toolsUrl(postId)),
  save: async (postId: string, body: Record<string, unknown>) => {
    if (body.action === 'bookmark') bookmarksService.invalidateReads();
    const owner = useSessionStore.getState().accounts.find((a) => a.useThisAsActive)?.handle;
    const result = await api<ToolsState>(toolsUrl(postId), { method: 'POST', body });
    if (
      body.action === 'bookmark' &&
      owner === useSessionStore.getState().accounts.find((a) => a.useThisAsActive)?.handle
    ) {
      bookmarksService.invalidateReads();
      void bookmarksService.list().catch(() => {});
    }
    return result;
  },
  library: () => api<Library>('/discussion-tools/library/'),
  invitations: () => api<Invitation[]>('/discussion-tools/invitations/'),
};
